import { WebPlugin } from '@capacitor/core';

import type {
  ContentsquareCAPPlugin,
  CustomVarItem,
  DynamicVarItem,
  PIIConfig,
  TelemetryItem,
  TransactionItem,
} from './definitions';

export class ContentsquareCAPWeb
  extends WebPlugin
  implements ContentsquareCAPPlugin {
  async sendTransaction(_transactionItem: TransactionItem): Promise<any> {
    throw new Error('Method not implemented.');
  }
  async sendDynamicVarWithIntValue(
    _dynamicVarItem: DynamicVarItem,
  ): Promise<any> {
    throw new Error('Method not implemented.');
  }
  async sendDynamicVarWithStringValue(
    dynamicVarItem: DynamicVarItem,
  ): Promise<any> {
    console.log('sendDynamicVarWithStringValue', dynamicVarItem);
    throw new Error('Method not implemented.');
  }
  async sendScreenName(_options: {
    name: string;
    cvars?: CustomVarItem[];
  }): Promise<any> {
    throw new Error('Method sendScreenName not implemented.');
  }
  async optIn(): Promise<void> {
    throw new Error('Method optIn not implemented.');
  }
  async optOut(): Promise<void> {
    throw new Error('Method optOut not implemented.');
  }
  async excludeURLForReplay(_options: { url: string }): Promise<void> {
    throw new Error('Method excludeURLForReplay not implemented.');
  }
  async setPIISelectors(_pii: PIIConfig): Promise<void> {
    throw new Error('Method excludeURLForReplay not implemented.');
  }
  async setCapturedElementsSelector(_options: {
    elements: string;
  }): Promise<void> {
    throw new Error('Method excludeURLForReplay not implemented.');
  }
  async onReady(): Promise<void> {
    throw new Error('Method onReady not implemented.');
  }
  async collect(_telemetryItem: TelemetryItem): Promise<void> {
      throw new Error('Method collect not implemented.');
  }
}
